import axios from 'axios'
import toast from 'react-hot-toast'
import { bffBaseURL } from './apiClient'

// ============================================================================
// Chat API
// ============================================================================

export async function sendMessage(data: any) {
  try {
    const response = await axios.post(
      `${bffBaseURL}/api/chat/send`,
      data
    )
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      toast.error('Failed to send message')
    }
    throw error
  }
}

export async function getChatContext(conversationId?: string) {
  try {
    const params = conversationId ? `?conversation_id=${conversationId}` : ''
    const response = await axios.get(
      `${bffBaseURL}/api/chat/context${params}`
    )
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      toast.error('Failed to load chat context')
    }
    throw error
  }
}
